import { Controller } from "stimulus";

// Reveals the "add item" input when the + button is clicked and focuses it.
// The checklist re-renders (Turbo Stream) on each change, collapsing again.
export default class extends Controller {
  static targets = ["form", "input"];

  add(event) {
    if (event) event.preventDefault();
    this.formTarget.classList.remove("hidden");
    this.inputTarget.focus();
  }

  cancel(event) {
    if (event) event.preventDefault();
    this.inputTarget.value = "";
    this.formTarget.classList.add("hidden");
  }
}
